import axios from 'axios'
import api from '@/api'
import ticketApi from '@/api/ticket'
import ticket3AdminManagementApi from '@/api/ticket3/admin-management'
import ticket3AgentManagementApi from '@/api/ticket3/agent-management'
import tcpApi from '@/api/tcp'
import logoutApi from '@/api/logout'
import { PAGE } from '@/constants/page'
import { notificationNewChatMessage } from '@/utils/notification'
import cloneDeep from 'lodash/cloneDeep'

import moment from 'moment'
import VueCookies from 'vue-cookies'
import CryptoJS from 'crypto-js'

import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
import stateConfig from './config'

import powerbuyShopServicesApi from '@/api/powerbuy-shop-services'
import { handleApiError, handleResponse } from '@/api/util'

import ticket3PageApi from '@/api/ticket3/page.js'
Vue.use(VueLocalStorage)

import intentApi from '@/api/intent.js'
import dayjs from 'dayjs'
import chatlogApi from '@/api/chatlog'
import botProfileApi from '@/api/bot-profile/bot-profile.js'
import pageConfigApi from '@/api/page-config'
import facebookShopApi from '@/api/facebook-shop'

export default {
  setLang: function ({ commit }, payload) {
    commit(stateConfig.SET_LANG, payload)
  },
  loading: function ({ commit }) {
    commit(stateConfig.LOADING)
  },
  clear_loading: function ({ commit }) {
    commit(stateConfig.CLEAR_LOADING)
  },
  login: function ({ commit, dispatch }, creds) {
    commit(stateConfig.LOGIN) // show spinner
    return new Promise((resolve, reject) => {
      api.authDefault(creds, function (error, response) {
        if (error) {
          commit(stateConfig.LOGIN_FAIL)

          reject(error)
          return
        }
        if (response.responsecode === 400) {
          resolve({
            code: response.responsecode,
            reason: response.reason
          })
        } else if (response.responsecode === 200) {
          dispatch('setAccountSession', { ...response, userid: creds.userid })
          commit(stateConfig.LOGIN_SUCCESS)
          resolve({
            code: response.responsecode
          })
        }
      })
    })
  },
  setAccountSession({ state }, payload) {
    state.botlist = payload.botlist

    state.userid = payload.userid
    state.isFacebook = false
    state.loginChannel = 'account'
    state.accessToken = payload.sessiontoken

    if (state.botlist.length == 0) {
      state.newcomer = true
      Vue.localStorage.set('newcomer', state.newcomer)
    } else {
      state.newcomer = false
      Vue.localStorage.set('newcomer', state.newcomer)
    }

    Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
    Vue.localStorage.set('userid', state.userid)
    Vue.localStorage.set('token', state.accessToken)
    Vue.localStorage.set('FB', state.isFacebook)
    Vue.localStorage.set('loginChannel', state.loginChannel)

    const secret = 'q6cczzkutlgjd9t3ji47h'
    const message = `${state.userid}__${state.accessToken}`
    const encrypted = CryptoJS.AES.encrypt(message, secret)

    let domain = '.zwiz.app'
    if (window.location.hostname === 'localhost') domain = '.localhost'
    VueCookies.set('_zwt', String(encrypted), '7d', null, domain, true, 'None')

    if (payload.admingroupid) {
      state.admingroupid = payload.admingroupid
      Vue.localStorage.set('admingroupid', state.admingroupid)
    }
    if (payload.adminsubgroupid) {
      state.adminsubgroupid = payload.adminsubgroupid
      Vue.localStorage.set('adminsubgroupid', state.adminsubgroupid)
    }
    try {
      if (payload.privilege) {
        state.privilege = JSON.parse(payload.privilege)
        Vue.localStorage.set('privilege', JSON.stringify(state.privilege))
      }
    } catch (error) {
      state.privilege = null
    }

    if (payload.partner_code) {
      state.partner_code = payload.partner_code
      Vue.localStorage.set('partner_code', state.partner_code)
    } else {
      state.partner_code = undefined
      Vue.localStorage.set('partner_code', state.partner_code)
    }
  },
  loginFB: function ({ commit, state, dispatch }, creds) {
    commit(stateConfig.LOGIN)
    return new Promise((resolve, reject) => {
      api.getLongLiveToken(creds, function (error, response) {
        if (error) {
          commit(stateConfig.LOGIN_FAIL)
          reject(error)
          return
        }

        api.getPageList(
          { token: response.longlivetoken },
          function (errorPageList, responsePageList) {
            if (errorPageList) {
              commit(stateConfig.LOGIN_FAIL)
              reject(new Error(error))
            }

            let pagelist = []
            if (responsePageList) {
              pagelist = responsePageList.map(function (page) {
                return page.id
              })
            }

            state.userid = creds.userid
            state.pagelist = responsePageList
            state.fbAccessToken = response.longlivetoken
            state.isFacebook = true
            state.loginChannel = creds.channel
            state.fbScope = creds.scope

            Vue.localStorage.set('fbtoken', state.fbAccessToken)
            Vue.localStorage.set('userid', state.userid)
            Vue.localStorage.set('pagelist', JSON.stringify(state.pagelist))
            Vue.localStorage.set('FB', state.isFacebook)
            Vue.localStorage.set('loginChannel', state.loginChannel)
            Vue.localStorage.set('fbScope', state.fbScope)
            let data = {
              userid: creds.userid,
              pageidlist: pagelist,
              access_token: state.fbAccessToken
            }
            dispatch('getBotlist', data).then(
              () => {
                commit(stateConfig.LOGIN_SUCCESS)
                resolve()
              },
              (error) => {
                commit(stateConfig.LOGIN_FAIL)
                reject(error)
              }
            )
          }
        )
      })
    })
  },
  loginFBPowerbuy: function ({ commit, state, dispatch }, creds) {
    commit(stateConfig.LOGIN)
    return new Promise((resolve, reject) => {
      api.getLongLiveToken(creds, function (error, response) {
        if (error) {
          commit(stateConfig.LOGIN_FAIL)
          reject(error)
          return
        }

        api.getPageList(
          { token: response.longlivetoken },
          function (errorPageList, responsePageList) {
            if (errorPageList) {
              commit(stateConfig.LOGIN_FAIL)
              reject(new Error(error))
            }

            let pagelist = []
            if (responsePageList) {
              pagelist = responsePageList.map(function (page) {
                return page.id
              })
            }

            // state.userid = creds.userid
            state.pagelist = responsePageList
            // state.fbAccessToken = response.longlivetoken
            state.isFacebook = true
            state.loginChannel = creds.channel
            state.fbScope = creds.scope

            // Vue.localStorage.set('fbtoken', state.fbAccessToken)
            // Vue.localStorage.set('userid', state.userid)
            Vue.localStorage.set('pagelist', JSON.stringify(state.pagelist))
            Vue.localStorage.set('FB', state.isFacebook)
            Vue.localStorage.set('loginChannel', state.loginChannel)
            Vue.localStorage.set('fbScope', state.fbScope)
            let data = {
              userid: creds.userid,
              pageidlist: pagelist,
              access_token: response.longlivetoken
            }
            dispatch('getBotlistPowerbuy', data).then(
              () => {
                commit(stateConfig.LOGIN_SUCCESS)
                resolve()
              },
              (error) => {
                commit(stateConfig.LOGIN_FAIL)
                reject(error)
              }
            )
          }
        )
      })
    })
  },
  updateNewBotlist: function ({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      let pagelist = []
      if (state.pagelist) {
        state.pagelist.map(function (value) {
          pagelist.push(value.id)
        })
      }

      let data = {
        userid: state.userid,
        pageidlist: pagelist,
        access_token: state.fbAccessToken
      }
      dispatch('getBotlist', data).then(
        () => {
          // commit(stateConfig.LOGIN_SUCCESS)
          if (state.selectedBot != null) {
            if (state.botlist) {
              state.botlist.map(function (val) {
                if (val.pageid === state.selectedBot.pageid) {
                  dispatch('selectBot', val)
                  return false
                }
              })
            }
          }
          resolve()
        },
        (error) => {
          // commit(stateConfig.LOGIN_FAIL)
          reject(error)
        }
      )
    })
  },
  getBotlist: function ({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      api.checkBotlist(data, function (error, response) {
        if (error) {
          reject(new Error(error))
        }

        if (response && response.pageidlist) {
          let botlist = response.botlist
          // state.botlist = botlist
          commit('SET_BOTLIST', botlist)
          state.accessToken = response.sessiontoken
          if (state.isFacebook)
            state.facebook_name = response.facebook_name ? response.facebook_name : ''
          else state.facebook_name = state.userid

          if (response.admingroupid) {
            state.admingroupid = response.admingroupid
            Vue.localStorage.set('admingroupid', state.admingroupid)
          }
          if (response.adminsubgroupid) {
            state.adminsubgroupid = response.adminsubgroupid
            Vue.localStorage.set('adminsubgroupid', state.adminsubgroupid)
          }
          try {
            if (response.privilege) {
              state.privilege = JSON.parse(response.privilege)
              Vue.localStorage.set('privilege', JSON.stringify(state.privilege))
            }
          } catch (error) {
            state.privilege = null
          }

          Vue.localStorage.set('facebook_name', state.facebook_name)
          Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
          Vue.localStorage.set('token', state.accessToken)
          if (response.partner_code) {
            state.partner_code = response.partner_code
            Vue.localStorage.set('partner_code', state.partner_code)
          } else {
            state.partner_code = undefined
            Vue.localStorage.set('partner_code', state.partner_code)
          }
        }
        resolve()
      })
    })
  },
  getBotlistPowerbuy: function ({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      api.checkBotlist(data, function (error, response) {
        if (error) {
          reject(new Error(error))
        }

        if (response && response.pageidlist) {
          let botlist = response.botlist
          // state.botlist = botlist
          commit('SET_BOTLIST', botlist)
          // state.accessToken = response.sessiontoken
          if (state.isFacebook)
            state.facebook_name = response.facebook_name ? response.facebook_name : ''
          else state.facebook_name = state.userid

          if (response.admingroupid) {
            state.admingroupid = response.admingroupid
            Vue.localStorage.set('admingroupid', state.admingroupid)
          }
          if (response.adminsubgroupid) {
            state.adminsubgroupid = response.adminsubgroupid
            Vue.localStorage.set('adminsubgroupid', state.adminsubgroupid)
          }
          try {
            if (response.privilege) {
              state.privilege = JSON.parse(response.privilege)
              Vue.localStorage.set('privilege', JSON.stringify(state.privilege))
            }
          } catch (error) {
            state.privilege = null
          }

          Vue.localStorage.set('facebook_name', state.facebook_name)
          Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
          Vue.localStorage.set('token', state.accessToken)
          if (response.partner_code) {
            state.partner_code = response.partner_code
            Vue.localStorage.set('partner_code', state.partner_code)
          } else {
            state.partner_code = undefined
            Vue.localStorage.set('partner_code', state.partner_code)
          }
        }
        resolve()
      })
    })
  },
  logout: async function ({ commit, state }, error) {
    if (state.accessToken) {
      try {
        logoutApi.postLogout()
      } catch (error) {
        console.error(error)
      }
    }
    let domain = '.zwiz.app'
    if (window.location.hostname === 'localhost') domain = '.localhost'
    VueCookies.remove('_zwt', '/', domain)
    VueCookies.remove('_zwb', '/', domain)

    Vue.localStorage.remove('token')
    Vue.localStorage.remove('userid')
    Vue.localStorage.remove('botlist')
    Vue.localStorage.remove('selectedBot')
    Vue.localStorage.remove('fbtoken')
    // Vue.localStorage.remove('FB')
    Vue.localStorage.remove('pagelist')
    Vue.localStorage.remove('partner_code')

    Vue.localStorage.remove('admingroupid')
    Vue.localStorage.remove('adminsubgroupid')
    Vue.localStorage.remove('privilege')

    state.admingroupid = null
    state.adminsubgroupid = null
    state.privilege = null

    state.userid = null
    state.botlist = null
    state.selectedBot = null
    state.isSelectedBot = false
    // state.isFacebook = false
    state.accessToken = null
    state.fbAccessToken = null
    state.pagelist = null
    state.partner_code = undefined
    if (error) {
      state.systemError = error
    }
    // eslint-disable-next-line no-undef
    if ($('.modal-backdrop')) {
      // eslint-disable-next-line no-undef
      $('.modal-backdrop').remove()
    }
    commit(stateConfig.LOGOUT)

    return true
  },
  selectBot: function ({ state, commit, dispatch }, bot) {
    if (state.selectedBot && bot && bot.pageid !== state.selectedBot.pageid) {
      dispatch('updatePaypalTrackingId', null)
    }
    Vue.localStorage.set('selectedBot', JSON.stringify(bot))

    let domain = '.zwiz.app'
    if (window.location.hostname === 'localhost') domain = '.localhost'
    VueCookies.set('_zwb', bot.pageid, '30d', null, domain, true, 'None')

    commit(stateConfig.SELECT_NEW_BOT, bot)
    commit(stateConfig.SELECT_BOT)
  },
  unselectBot: function ({ state, dispatch }) {
    dispatch('updatePaypalTrackingId', null)
    Vue.localStorage.remove('selectedBot')
    state.selectedBot = null
    state.isSelectedBot = false
  },
  updateBotlist: function ({ state }, botlist) {
    state.botlist = botlist
    Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
  },
  updatePagelist: function ({ state }) {
    if (!state.isFacebook) {
      return false
    }
    api.getPageList({ token: state.fbAccessToken }, function (error, response) {
      if (error) {
        console.error(error)
        return false
      }

      state.pagelist = response
      Vue.localStorage.set('pagelist', JSON.stringify(state.pagelist))

      return true
    })
  },
  sidebar: function ({ commit }, value) {
    if (value) {
      commit(stateConfig.SIDEBAR)
    }
    commit(stateConfig.SIDEBAR)
  },
  updatePaypalTrackingId: function ({ state }, value) {
    state.paypalTrackingId = value
    if (value == null) {
      Vue.localStorage.remove('paypalTrackingId')
    } else {
      Vue.localStorage.set('paypalTrackingId', state.paypalTrackingId)
    }
  },
  updateMerchantId: function ({ commit, state }, value) {
    state.selectedBot.paypal_merchantid = value
    Vue.localStorage.set('selectedBot', JSON.stringify(state.selectedBot))

    let domain = '.zwiz.app'
    if (window.location.hostname === 'localhost') domain = '.localhost'
    VueCookies.set('_zwb', state.selectedBot.pageid, '30d', null, domain, true, 'None')

    commit(stateConfig.SELECT_NEW_BOT, state.selectedBot)
    commit(stateConfig.SELECT_BOT)
  },
  updateSetting: function ({ commit }, value) {
    commit(stateConfig.UPDATE_SETTING, value)
  },
  updateWelcomeMessage: function ({ commit }, value) {
    commit(stateConfig.UPDATE_WELCOME_MESSAGE, value)
  },
  updateBotDetail: function ({ commit, state }) {
    return new Promise((resolve, reject) => {
      let data = { pageid: state.selectedBot.pageid }
      api.getBotDetail(data, function (error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.data) {
          if (Object.prototype.hasOwnProperty.call(response.data, 'page_access_token')) {
            delete response.data.page_access_token
          }
          state.selectedBot = { ...state.selectedBot, ...response.data }

          Vue.localStorage.set('selectedBot', JSON.stringify(state.selectedBot))
          let domain = '.zwiz.app'
          if (window.location.hostname === 'localhost') domain = '.localhost'
          VueCookies.set('_zwb', state.selectedBot.pageid, '30d', null, domain, true, 'None')

          if (state.botlist) {
            state.botlist.map(function (bot, index) {
              if (bot.pageid === state.selectedBot.pageid) {
                state.botlist[index] = state.selectedBot
                Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
                return false
              }
            })
          }
          commit(stateConfig.SELECT_BOT)
        }

        resolve(response)
      })
    })
  },
  addModalWelcome: function ({ commit }) {
    commit(stateConfig.UPDATE_MODAL_WELCOME, true)
  },
  clearModalWelcome: function ({ commit }) {
    commit(stateConfig.UPDATE_MODAL_WELCOME, false)
  },
  clearAlert: function ({ state, commit }, name) {
    var pageid = null
    if (state.selectedBot) {
      pageid = state.selectedBot.pageid
    }
    commit(stateConfig.UPDATE_ALERT, { name: name, show: false, pageid: pageid })
  },
  getProducts: function ({ state }) {
    return new Promise((resolve, reject) => {
      if (state.selectedBot && ['powerbuy'].includes(state.selectedBot.theme)) {
        const data = {
          config: {
            params: {
              pageId: state.selectedBot.pageid
            }
          }
        }
        try {
          powerbuyShopServicesApi.getProducts(data).then((response) => {
            handleResponse().then(() => {
              if (response.data && response.data.data) {
                resolve(response.data.data)
              } else {
                resolve([])
              }
            })
          })
        } catch (error) {
          handleApiError(error)
          reject(error)
        }
      } else if (state.thailandPostmartPage.includes(state.selectedBot.pageid)) {
        let data = {
          slug: 'all',
          pageid: state.selectedBot.pageid
        }
        api.getProductBySlugThailandPostmart(data, function (error, response) {
          if (error) {
            reject(error)
            return
          }
          if (response.data) {
            resolve(response.data)
          } else {
            reject()
          }
        })
      } else {
        let data = {
          pageid: state.selectedBot.pageid
        }
        if (
          state.selectedBot.useketshop == true &&
          state.selectedBot.ketshop_api_key &&
          state.selectedBot.ketshop_api_secret
        ) {
          data['ketshop_api_key'] = state.selectedBot.ketshop_api_key
          data['ketshop_api_secret'] = state.selectedBot.ketshop_api_secret
        }

        if (
          state.selectedBot &&
          ['powerbuy'].includes(state.selectedBot.theme) &&
          state.powerbuyMainBranch
        ) {
          Object.assign(data, { shop_main_pageid: state.powerbuyMainBranch })
        }

        api.getProducts(data, function (error, response) {
          if (error) {
            reject(error)
            return
          }
          if (response.productlist) {
            resolve(response.productlist)
          } else {
            reject()
          }
        })
      }
    })
  },
  loadProducts: function ({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.ecommerce.loadingProduct = true
      dispatch('getProducts').then(
        (products) => {
          state.ecommerce.products = products
          state.ecommerce.loadingProduct = false

          resolve()
        },
        (error) => {
          console.error(error)
          state.ecommerce.loadingProduct = false
          reject(error)
        }
      )
    })
  },
  getCategories: function ({ state }) {
    return new Promise((resolve, reject) => {
      if (state.selectedBot && ['powerbuy'].includes(state.selectedBot.theme)) {
        const data = {
          config: {
            params: {
              pageId: state.selectedBot.pageid
            }
          }
        }
        try {
          powerbuyShopServicesApi.getCategories(data).then((response) => {
            handleResponse().then(() => {
              if (response.data && response.data.data) {
                resolve(response.data.data)
              } else {
                resolve([])
              }
            })
          })
        } catch (error) {
          handleApiError(error)
          reject(error)
        }
      } else if (state.thailandPostmartPage.includes(state.selectedBot.pageid)) {
        api.getCategoriesThailandPostmart(
          { pageid: state.selectedBot.pageid },
          function (error, response) {
            if (error) {
              reject(error)
              return
            }
            if (response.data) {
              resolve(response.data)
            } else {
              reject()
            }
          }
        )
      } else {
        var data = {
          pageid: state.selectedBot.pageid
        }
        if (
          state.selectedBot.useketshop == true &&
          state.selectedBot.ketshop_api_key &&
          state.selectedBot.ketshop_api_secret
        ) {
          data['ketshop_api_key'] = state.selectedBot.ketshop_api_key
          data['ketshop_api_secret'] = state.selectedBot.ketshop_api_secret
        }

        if (
          state.selectedBot &&
          ['powerbuy'].includes(state.selectedBot.theme) &&
          state.powerbuyMainBranch
        ) {
          Object.assign(data, { shop_main_pageid: state.powerbuyMainBranch })
        }

        api.getCategories(data, function (error, response) {
          if (error) {
            reject(error)
            return
          }
          if (response.categorylist) {
            resolve(response.categorylist)
          } else {
            reject()
          }
        })
      }
    })
  },
  loadCategory: function ({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.ecommerce.loadingCategory = true
      dispatch('getCategories').then(
        (categories) => {
          state.ecommerce.categories = categories
          state.ecommerce.loadingCategory = false
          resolve()
        },
        (error) => {
          console.error(error)
          state.ecommerce.loadingCategory = false
          reject(error)
        }
      )
    })
  },
  getUserStatus: function ({ state }) {
    return new Promise((resolve, reject) => {
      let data = {
        pageid: state.selectedBot.pageid
      }

      var selectedApi = 'getUserStatus'
      if (['studio7', 'ticket2'].includes(state.selectedBot.theme)) {
        data.pageid = state.selectedCom7page.pageid
          ? state.selectedCom7page.pageid
          : state.selectedBot.pageid
        selectedApi = 'getcom7userstatus'
      }

      api[selectedApi](data, function (error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.data) {
          resolve(response.data)
        } else {
          reject()
        }
      })
    })
  },
  loadStatus: function ({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingUserStatus = true
      dispatch('getUserStatus').then(
        (status) => {
          state.userStatus = []
          if (status.length > 0) {
            status.map((val) => {
              state.userStatus.push(val.status)
            })
          }
          state.loadingUserStatus = false
          resolve()
        },
        (error) => {
          console.error(error)
          state.loadingUserStatus = false
          reject(error)
        }
      )
    })
  },
  getSetting: function ({ state }) {
    return new Promise((resolve, reject) => {
      api.getSetting({ pageid: state.selectedBot.pageid }, function (error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.data) {
          resolve(response.data)
        } else {
          reject()
        }
      })
    })
  },
  loadSetting: function ({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingSetting = true
      dispatch('getSetting').then(
        (setting) => {
          var contents = []
          setting.map(function (content) {
            contents[content.contenttype] = content
          })
          state.setting = contents
          state.loadingSetting = false
          resolve()
        },
        (error) => {
          console.error(error)
          state.loadingSetting = false
          reject(error)
        }
      )
    })
  },
  getCharges: function ({ state }) {
    return new Promise((resolve, reject) => {
      api.getAllShipingCharge({ pageid: state.selectedBot.pageid }, function (error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.shippinglist) {
          resolve(response.shippinglist)
        } else {
          reject()
        }
      })
    })
  },
  loadCharges: function ({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.ecommerce.loadingCharges = true
      dispatch('getCharges').then(
        (charges) => {
          state.ecommerce.charges = charges
          state.ecommerce.loadingCharges = false
          resolve()
        },
        (error) => {
          console.error(error)
          state.ecommerce.loadingCharges = false
          reject(error)
        }
      )
    })
  },
  getGroupConversation: function ({ state }) {
    return new Promise((resolve, reject) => {
      api.getGroupConversationByPageId(
        { pageid: state.selectedBot.pageid },
        function (error, response) {
          if (error) {
            reject(error)
            return
          }
          if (response.groupsConversation) {
            resolve(response.groupsConversation)
          } else {
            reject()
          }
        }
      )
    })
  },
  loadGroupConversation: function ({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingGroupConversation = true
      dispatch('getGroupConversation').then(
        (GroupConversation) => {
          state.groupConversation = GroupConversation
          state.loadingGroupConversation = false
          resolve()
        },
        (error) => {
          console.error(error)
          state.loadingGroupConversation = false
          reject(error)
        }
      )
    })
  },
  getLinePushMessageCount: function ({ state }, value) {
    return new Promise((resolve, reject) => {
      var data = { pageid: state.selectedBot.pageid }
      if (value && (value.datefrom || value.dateto)) {
        data.datefrom = moment(value.datefrom).format('YYYY-MM-DD')
        data.dateto = moment(value.dateto).format('YYYY-MM-DD')
      }

      api.getLinePushMessageCount(data, function (error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.data) {
          resolve(response.data)
        } else {
          reject()
        }
      })
    })
  },
  updateLivechatUsers: function ({ state, getters, commit }, payload) {
    commit(stateConfig.SET_LIVECHAT_USERS, payload)

    if (PAGE.PRUDENTIAL.includes(getters.selectedBot.pageid)) {
      const { users } = payload
      const { userid: currentUserId } = getters.livechat.currentUser || {}
      const targetUser = users.find(({ userid }) => userid === currentUserId)
      if (targetUser && currentUserId) {
        Object.assign(state.livechat.currentUser, {
          is_user_online: targetUser.is_user_online
        })
      }
    }
  },
  updateLivechatUser: function ({ commit }, payload) {
    commit(stateConfig.SET_LIVECHAT_USER, payload)
  },
  handleRemoveUserFromAdminTap: function ({ state, commit }, payload) {
    if (state.livechat.userlist[payload.type]) {
      const users = state.livechat.userlist[payload.type].users.filter(
        (user) => user.userid !== payload.user_id
      )
      commit(stateConfig.SET_LIVECHAT_USERS, { users, type: payload.type })
    }
  },
  handleUpdateLivechatUser: function ({ state, commit }, payload) {
    // {
    //   data: Object,
    //   type: String,
    //   user_id: String
    // }
    const user_id = payload.user_id || null
    if (user_id) {
      if (state.livechat.userlist[payload.type]) {
        const userIndex = state.livechat.userlist[payload.type].users.findIndex(
          (user) => user.userid === user_id
        )
        if (userIndex != -1) {
          const users = cloneDeep(state.livechat.userlist[payload.type].users)
          users[userIndex] = { ...users[userIndex], ...payload.data }
          commit(stateConfig.SET_LIVECHAT_USERS, { users, type: payload.type })
        }
      }
      if (state.livechat.currentUser && state.livechat.currentUser.userid == user_id) {
        commit(stateConfig.SET_LIVECHAT_USER, { ...state.livechat.currentUser, ...payload.data })
      }
    }
  },
  loadLinePushMessageCount: function ({ state, dispatch }, value) {
    return new Promise((resolve, reject) => {
      state.loadingLinePushMessageCount = true
      dispatch('getLinePushMessageCount', value).then(
        (linePushMessageCount) => {
          state.linePushMessageCount = linePushMessageCount
          state.loadingLinePushMessageCount = false
          resolve()
        },
        (error) => {
          console.error(error)
          state.loadingLinePushMessageCount = false
          reject(error)
        }
      )
    })
  },
  updateKetshopToken: function ({ commit }, payload) {
    commit(stateConfig.SET_KETSHOP_TOKEN, payload)
  },
  async forceLoadLastestUsers({ state, dispatch }) {
    for (const key in state.livechat.userlist) {
      if (Object.prototype.hasOwnProperty.call(state.livechat.userlist, key)) {
        state.livechat.userlist[key].offset = 0
        state.livechat.userlist[key].limit = state.livechat.limitFatchUser
        state.livechat.userlist[key].loading = false
        state.livechat.userlist[key].hasMore = true

        await dispatch('loadLivechatUsers', {
          type: key
        })
      }
    }
  },
  async loadLatestUsers({ state, dispatch }, payload) {
    if (state.livechat.userlist[payload.type]) {
      var user_config = state.livechat.userlist[payload.type]
      if (user_config.loading || !user_config.isAutoRefresh) {
        return false
      }

      state.livechat.userlist[payload.type].offset = 0
      state.livechat.userlist[payload.type].limit = state.livechat.limitFatchUser

      await dispatch('loadLivechatUsers', payload)
    }
  },
  loadLivechatUsers({ state, getters, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      if (state.livechat.userlist[payload.type]) {
        state.livechat.userlist[payload.type].loading = true
        if (getters.getLivechatSearching.length > 0) {
          state.livechat.currentLoadMonth = state.livechat.loadMonth
        }
        dispatch('getLivechatUsers', payload).then(
          (users) => {
            // if (
            //   users.length == state.livechat.userlist[payload.type].users.length &&
            //   getters.getLivechatSearching.length == 0 &&
            //   state.livechat.currentLoadMonth < 18
            // ) {
            //   state.livechat.currentLoadMonth =
            //     state.livechat.currentLoadMonth + state.livechat.loadMonth
            // }

            if (payload.type === 'admin' && getters.selectedBot.pageid === PAGE.COTTO) {
              notificationNewChatMessage({
                users,
                timeInterval: getters.getLivechatDetail('maxFetchUserTime')
              })
            }
            dispatch('updateLivechatUsers', { users: users, type: payload.type })
            // if user less than limit or equal to zero. Livechat will not be fatch new user after 5 sec
            if (
              state.livechat.userlist[payload.type].users.length <
                state.livechat.userlist[payload.type].limit ||
              state.livechat.userlist[payload.type].users.length == 0
            ) {
              state.livechat.userlist[payload.type].hasMore = false

              // Refresh user list every 30 sec
              // Only KFC
              if (getters.selectedBot.pageid === '106855151601601') {
                setTimeout(() => {
                  state.livechat.userlist[payload.type].hasMore = true
                }, 30000)
              } else {
                setTimeout(() => {
                  state.livechat.userlist[payload.type].hasMore = true
                }, 5000)
              }
            }
            state.livechat.userlist[payload.type].loading = false
            resolve()
          },
          (error) => {
            state.livechat.userlist[payload.type].loading = false
            reject(error)
          }
        )
      }
    })
  },
  getLivechatUsers: function ({ state, getters, commit }, payload) {
    return new Promise((resolve, reject) => {
      var filter = {}
      let pageid = state.livechat.pageid
      if (!pageid && getters.selectedBot) {
        pageid = getters.selectedBot.pageid
      }
      if (getters.selectedBot && getters.selectedBot.theme == 'universalutilities') {
        if (getters.selectedBot.uu_areaname) {
          filter.uu_areaname = getters.selectedBot.uu_areaname.toLowerCase()
        } else if (state.filter.uuAreaName) {
          filter.uuAreaName = state.filter.uuAreaName.toLowerCase()
        }
        if (state.filter.lineid) {
          filter.lineid = state.filter.lineid.toLowerCase()
        }
        if (state.filter.uu_register_status) {
          filter.uu_register_status = state.filter.uu_register_status.toLowerCase()
        }
        if (state.filter.phoneno) {
          filter.phoneno = state.filter.phoneno.toLowerCase()
        }
        if (state.filter.uu_name) {
          filter.uu_name = state.filter.uu_name.toLowerCase()
        }
        if (state.filter.lastconversationfrom) {
          filter.lastconversationfrom = state.filter.lastconversationfrom
        }
        if (state.filter.lastconversationto) {
          filter.lastconversationto = state.filter.lastconversationto
        }
        if (state.filter.keyword) {
          filter.keyword = state.filter.keyword.toLowerCase()
        }
      }
      if (state.filter.search) {
        filter.search = state.filter.search.toLowerCase()
      }
      if (state.filter.assignadminid) {
        filter.assignadminid = state.filter.assignadminid
      }
      if (state.filter.assigngroupid) {
        filter.assigngroupid = state.filter.assigngroupid
      }
      if (state.filter.assignsubgroupid) {
        filter.assignsubgroupid = state.filter.assignsubgroupid
      }

      filter.is_search = false
      if (state.livechat.app == 'facebook' && state.privilege && state.privilege.pinUserFacebook) {
        filter.pin_user = state.privilege.pinUserFacebook
      } else if (state.livechat.app == 'line' && state.privilege && state.privilege.pinUserLine) {
        filter.pin_user = state.privilege.pinUserLine
      } else {
        let pin_pool = []
        if (state.privilege && state.privilege.pinUserFacebook) {
          pin_pool.push(state.privilege.pinUserFacebook.split(','))
        }
        if (state.privilege && state.privilege.pinUserLine) {
          pin_pool.push(state.privilege.pinUserLine.split(','))
        }
        filter.pin_user = pin_pool.join(',')
      }

      // KFC
      if (['102052945584054', '106855151601601'].includes(pageid)) {
        commit('SET_LIVECHAT_APP', 'line')
      }

      var data = {
        params: {},
        body: {
          pageid: pageid,
          offset: state.livechat.userlist[payload.type].offset,
          limit: state.livechat.userlist[payload.type].limit,
          inbox: payload.type,
          app: state.livechat.app,
          status: state.livechat.status,
          tags: state.livechat.tags.join(','),
          ...filter
        }
      }

      if (getters.isLivechatSearching || state.livechat.filter.chatstatus) {
        data.body = {
          ...data.body,
          ...state.livechat.filter,
          tags: state.livechat.filter.tags.join(','),
          inbox: 'all'
        }
      } else {
        data.body.app = state.livechat.app
        data.body.inbox = payload.type
      }

      if (getters.isLivechatSearching) {
        if (state.livechat.filter.app == '' && state.livechat.filter.inbox == '') {
          delete data.body.app
          data.body.inbox = 'all'
        } else if (state.livechat.filter.app !== '' && state.livechat.filter.inbox == '') {
          data.body.app = state.livechat.filter.app
          data.body.inbox = 'all'
        } else if (state.livechat.filter.app == '' && state.livechat.filter.inbox !== '') {
          delete data.body.app
          data.body.inbox = state.livechat.filter.inbox
        } else {
          data.body.app = state.livechat.filter.app
          data.body.inbox = state.livechat.filter.inbox
        }
      }

      if (getters.selectedBot && getters.selectedBot.theme == 'universalutilities') {
        delete data.body.app
      }
      if (state.livechat.filter.search) {
        Object.assign(data.body, { search: state.livechat.filter.search })
      }
      if (state.livechat.filter.chatstatus) {
        Object.assign(data.body, { chatstatus: state.livechat.filter.chatstatus })
      }

      if (state.livechat.filter.datefrom && state.livechat.filter.dateto) {
        Object.assign(data.body, {
          datefrom: state.livechat.filter.datefrom,
          dateto: state.livechat.filter.dateto
        })
      }

      if (state.livechat.filter.adminread == null) {
        Object.assign(data.body, {
          adminread: null
        })
      } else {
        if (state.livechat.filter.app == '') {
          delete data.body.app
        }

        Object.assign(data.body, {
          adminread: state.livechat.filter.adminread
        })
      }

      var endpointurl = 'getLiveChatUsers'
      if (
        getters.selectedBot &&
        ['studio7', 'ustore', 'ticket2'].includes(getters.selectedBot.theme)
      ) {
        endpointurl = 'ticket2getLiveChatUsers'
        Object.assign(data.body, {
          role: state.privilege.role
        })

        if (state.livechat.filter.customrealname) {
          delete data.body.app
          data.body.inbox = 'all'
          Object.assign(data.body, { customrealname: state.livechat.filter.customrealname })
        }

        if (state.livechat.filter.email) {
          delete data.body.app
          data.body.inbox = 'all'
          Object.assign(data.body, { email: state.livechat.filter.email })
        }
      }

      if (getters.selectedBot.pageid == '100207768987988') {
        endpointurl = 'cottoGetUserthread'
        Object.assign(data.body, {
          role: state.privilege.role
        })
      }

      if (['tdtawandang'].includes(getters.selectedBot.theme)) {
        // adminGroupId: '',
        // adminSubGroupId: ''

        var addData = {
          role: state.privilege.role
        }

        if (state.privilege.role == 'supervisor' && state.privilege.view_ticket) {
          Object.assign(addData, { view_ticket: state.privilege.view_ticket })
        }
        endpointurl = 'TDgetLiveChatUsers'
        Object.assign(data.body, addData)
      }

      // NOTED: limit userthread by datefrom and dateto
      if (!data.body.datefrom && !data.body.dateto && getters.getLivechatSearching.length == 0) {
        Object.assign(data.body, {
          datefrom: dayjs().subtract(state.livechat.currentLoadMonth, 'M').format('YYYY-MM-DD'),
          dateto: dayjs().format('YYYY-MM-DD')
        })
      }

      api[endpointurl](data, function (error, response) {
        if (error) {
          reject(error)
        }
        if (response && response.data) {
          resolve(response.data)
        } else {
          resolve([])
        }
      })
    })
  },
  updateNewcomer: function ({ state }, payload) {
    state.newcomer = payload
    Vue.localStorage.set('newcomer', state.newcomer)
  },
  livechatnotiunread({ state }) {
    return new Promise((resolve) => {
      var data = {
        pageid: state.livechat.pageid
      }

      if (
        ['studio7', 'ustore'].includes(state.selectedBot.theme) ||
        state.selectedBot.pageid == '100207768987988'
      ) {
        Object.assign(data, { role: state.privilege.role })
      }

      api.livechatnotiunread(data, (err, response) => {
        const old_chatnotify = cloneDeep(state.newchatnotify)
        let found = false

        let new_chatnotify = response.data[0]
        for (const property in new_chatnotify) {
          const total = new_chatnotify[property] ? new_chatnotify[property] : 0
          new_chatnotify[property] = parseInt(total)
        }

        if (Object.keys(old_chatnotify).length > 0 && Object.keys(new_chatnotify).length > 0) {
          for (const property in new_chatnotify) {
            if (old_chatnotify[property] < new_chatnotify[property]) {
              found = true
              break
            }
          }
        }
        state.newchatnotify = new_chatnotify
        resolve(found)
      })
    })
  },
  getPageProfile: function ({ state }) {
    return new Promise((resolve, reject) => {
      let data = {
        pageid: state.selectedBot.pageid
      }
      api.getShopProfile(data, function (error, response) {
        if (error) {
          console.error(error)

          reject()
        }

        if (response.shopprofile) {
          resolve(response.shopprofile)
        } else {
          resolve(null)
        }
      })
    })
  },
  loadPageProfile: function ({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingPageProfile = true
      dispatch('getPageProfile').then(
        (profile) => {
          state.pageProfile = profile
          state.loadingPageProfile = false
          resolve()
        },
        (error) => {
          console.error(error)
          state.loadingPageProfile = false
          reject(error)
        }
      )
    })
  },
  getPartnerProfile: function ({ state }) {
    return new Promise((resolve, reject) => {
      api.getPartnerProfile({ partner_code: state.partner_code }, function (error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.data && response.data.length > 0) {
          resolve(response.data[0])
        } else {
          reject()
        }
      })
    })
  },
  loadPartnerProfile: function ({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingPartnerProfile = true
      dispatch('getPartnerProfile').then(
        (partnerProfile) => {
          state.partnerProfile = partnerProfile
          state.loadingPartnerProfile = false
          resolve()
        },
        (error) => {
          console.error(error)
          state.loadingPartnerProfile = false
          reject(error)
        }
      )
    })
  },
  getAgents: function ({ state }) {
    let data = {}
    return new Promise((resolve, reject) => {
      try {
        if (state.selectedBot.unlock_ticket_3) {
          ticket3AdminManagementApi
            .getAdminUser({
              params: {
                page_id: state.selectedBot.pageid,
                limit: 100
              }
            })
            .then((response) => {
              if (response.status == 200) {
                resolve(response.data.data || [])
              } else {
                reject()
              }
            })
            .catch((error) => {
              console.error(error)
              reject(error)
            })
        } else {
          if (['studio7', 'ticket2'].includes(state.selectedBot.theme)) {
            data = {
              pageid: state.com7pages[0].pageid
            }
          } else {
            data = {
              pageid: state.selectedBot.pageid
            }
          }

          api.getAdmins(data, (error, response) => {
            if (error) {
              console.error(error)
              reject(error)
            }
            resolve(response.data)
          })
        }
      } catch (error) {
        console.error(error)
        reject(error)
      }
    })
  },
  loadAgents: async function ({ state, dispatch }) {
    state.loadingAgents = true
    try {
      var agents = await dispatch('getAgents')

      state.agents = agents
    } catch (error) {
      console.error(error)
    }
    state.loadingAgents = false
  },
  getAdminGroup: function ({ state }) {
    return new Promise((resolve, reject) => {
      let pageid = state.selectedBot.pageid
      if (state.selectedBot.unlock_ticket_3) {
        ticket3AdminManagementApi
          .getAdminGroup({
            params: {
              page_id: pageid
            }
          })
          .then((response) => {
            if (response.status == 200) {
              resolve(response.data.data || [])
            } else {
              reject()
            }
          })
          .catch((error) => {
            console.error(error)
            reject(error)
          })
      } else {
        const isStudioPage =
          state.selectedBot && ['studio7', 'ticket2'].includes(state.selectedBot.theme)
        const isNestlePage =
          state.selectedBot &&
          state.nestlePages.some((page) => page.pageid == state.selectedBot.pageid)

        if (isStudioPage) {
          pageid = state.com7pages[0].pageid
        } else if (isNestlePage) {
          pageid = state.nestlePages[0].pageid
        }

        api.getAdminGroup({ pageid }, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response.data)
        })
      }
    })
  },
  loadAgentGroups: async function ({ state, dispatch }) {
    state.loadingAgentGroups = true
    try {
      const agents = await dispatch('getAdminGroup')
      state.agentGroups = agents ? agents : []
    } catch (error) {
      console.error(error)
    }
    state.loadingAgentGroups = false
  },
  getAdminSubGroup: function ({ state }) {
    return new Promise((resolve, reject) => {
      let pageid = state.selectedBot.pageid
      if (state.selectedBot.unlock_ticket_3) {
        ticket3AdminManagementApi
          .getAdminSubGroup({
            params: {
              page_id: pageid
            }
          })
          .then((response) => {
            if (response.status == 200) {
              resolve(response.data.data || [])
            } else {
              reject()
            }
          })
          .catch((error) => {
            console.error(error)
            reject(error)
          })
      } else {
        const isStudioPage =
          state.selectedBot && ['studio7', 'ticket2'].includes(state.selectedBot.theme)
        const isNestlePage =
          state.selectedBot &&
          state.nestlePages.some((page) => page.pageid == state.selectedBot.pageid)

        if (isStudioPage) {
          pageid = state.com7pages[0].pageid
        } else if (isNestlePage) {
          pageid = state.nestlePages[0].pageid
        }

        api.getAdminSubGroup({ pageid }, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response.data)
        })
      }
    })
  },
  loadAgentSubGroups: async function ({ state, dispatch }) {
    state.loadingAgentSubgroups = true
    try {
      var agents = await dispatch('getAdminSubGroup')
      state.agentSubgroups = agents ? agents : []
    } catch (error) {
      console.error(error)
    }
    state.loadingAgentSubgroups = false
  },
  toggleBotStatus({ state, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      var bot = payload

      api.toggleBotStatus(bot, function (error) {
        if (error) {
          reject(error)
        }

        let newbotlist = state.botlist
        var botIndex = newbotlist.findIndex((oldbot) => {
          return bot.pageid == oldbot.pageid
        })
        if (newbotlist) {
          newbotlist[botIndex].status = bot.status
          dispatch('selectBot', bot)
          dispatch('updateBotlist', newbotlist)
        }

        resolve()
      })
    })
  },
  getIntent: async function ({ state }) {
    try {
      const response = await intentApi.getIntent({
        params: {
          pageid: state.selectedBot.pageid,
          sort_by: 'intentname',
          sort_type_available: 'asc'
        }
      })
      await handleResponse(response)
      if (response.data.data) {
        return response.data.data
      } else {
        return {}
      }
    } catch (error) {
      handleApiError(error)
    }
  },
  loadIntent: function ({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      commit('SET_INTENTS', { intents: undefined, loadingIntents: true })
      dispatch('getIntent').then(
        (intents) => {
          commit('SET_INTENTS', { intents, loadingIntents: false })
          resolve()
        },
        (error) => {
          commit('SET_INTENTS', { intents: [], loadingIntents: false })
          reject(error)
        }
      )
    })
  },
  getTicketTags: async function ({ state, commit }, isForceUpdate = false) {
    try {
      if (
        isForceUpdate ||
        state.ticketTags == null ||
        state.selectedBot.pageid != state.ticketTagsPageId
      ) {
        let responseData = await ticketApi.getTicketTagsList(state.selectedBot.pageid, {})
        responseData = responseData.data.data
        const output = responseData.map((data) => {
          return data.name
        })
        commit('SET_TICKET_TAGS', output)
        commit('SET_TICKET_TAGS_FULL', responseData)
        commit('SET_TICKET_TAGS_PAGE_ID', state.selectedBot.pageid)
      }
    } catch (error) {
      console.error(error)
    }
  },
  updateTicketTags: async function ({ state, commit }, tags) {
    try {
      if (state.ticketTags && state.ticketTags.length) {
        let tempTags = [...state.ticketTags, ...tags]
        tempTags = [...new Set(tempTags)]
        commit('SET_TICKET_TAGS', tempTags)
      } else {
        commit('SET_TICKET_TAGS', tags)
      }
    } catch (error) {
      console.error(error)
    }
  },
  getTcpSubpages: async function ({ state, commit }) {
    try {
      const response = await tcpApi.getShopPageWithMasterPageId({
        master_page_id: state.selectedBot.pageid
      })

      if (response && response.status === 200) {
        commit('SET_TCP_SUBPAGES', response.data.data)
      }
    } catch (error) {
      console.error(error)
    }
  },
  getChatConfig: async function ({ state, commit, dispatch }) {
    try {
      dispatch('loading')
      const response = await chatlogApi.getConfigReadChatColor({
        config: {
          params: {
            page_id: state.selectedBot.pageid
          }
        }
      })
      dispatch('clear_loading')

      if (response && response.status === 200) {
        const responseConfigData = response.data.data.config || null
        commit('SET_CHAT_CONFIG', responseConfigData)
      }
    } catch (error) {
      console.error(error)
    } finally {
      dispatch('clear_loading')
    }
  },
  savePrivilege: function ({ commit }, privilege) {
    Vue.localStorage.set('privilege', privilege)
    commit('SET_PRIVILEGE', JSON.parse(Vue.localStorage.get('privilege')))
  },
  loadWrapUp: async function ({ state }, filter) {
    try {
      const response = await ticket3PageApi.getWrapUpRoute({
        params: {
          page_id: state.selectedBot.pageid,
          limit: filter && filter.limit ? filter.limit : undefined,
          offset: filter && filter.offset >= 0 ? filter.offset : undefined,
          ...filter
        }
      })
      if (response.status == 200) {
        return {
          data: response.data.data ? response.data.data : [],
          total: +response.data.total || 0
        }
      } else {
        return {
          data: [],
          total: 0
        }
      }
    } catch (error) {
      handleApiError(error)
      return false
    }
  },
  loadBotProfile: async function ({ state, commit }, options) {
    try {
      const response = await botProfileApi.getBotProfile({
        params: {
          page_id: state.selectedBot.pageid,
          ...options
        }
      })

      if (response && response.status === 200) {
        commit('SET_BOT_PROFILE', response.data)
      }
    } catch (error) {
      console.error(error)
    }
  },
  loadAgentStatusOnlineOffline: async function ({ dispatch, commit }) {
    await dispatch('getAgentStatusOnlineOffline')
    const timer = setInterval(async () => {
      await dispatch('getAgentStatusOnlineOffline')
    }, 1000 * 60 * 5)

    commit('SET_COUNT_AGENT_ONLINE_OFFLINE_TIMER', timer)
  },
  getAgentStatusOnlineOffline: async function ({ state, commit }) {
    try {
      const response = await ticket3AgentManagementApi.getCountAgentOnlineOffline({
        params: { page_id: state.selectedBot.pageid }
      })
      if (response && response.status === 200) {
        const responseData = response.data.data
        commit('SET_COUNT_AGENT_ONLINE_OFFLINE', responseData)
      }
    } catch (error) {
      console.error(error)
    }
  },
  getUserTags: async function () {
    try {
      var response = await api.getUserTagList()
      if (response && response.result) {
        return response.result
      }
    } catch (error) {
      console.log(error)
    }
  },
  loadTags: function ({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingUserTags = true
      dispatch('getUserTags').then(
        (tags) => {
          state.userTags = []
          if (tags.length > 0) {
            state.userTags = tags
          }
          state.loadingUserTags = false
          resolve()
        },
        (error) => {
          console.error(error)
          state.loadingUserTags = false
          reject(error)
        }
      )
      // if (state.userTags.length > 0) {
      //   resolve()
      //   state.loadingUserTags = false
      // } else {
      //   <Logic>
      // }
    })
  },
  updateFbPurchaseSetting: async function ({ getters, dispatch }, payload) {
    axios.defaults.headers.common = {
      AUTHORIZATION: getters.securityToken
    }

    try {
      const response = await pageConfigApi.postUpdatePageConfig(payload)
      if (response.status === 204) {
        await dispatch('updateBotDetail')
        return true
      } else {
        return false
      }
    } catch (error) {
      console.log({ error })
      return false
    }
  },
  connectMetaCatalog: async function ({ dispatch }, payload) {
    try {
      const response = await facebookShopApi.postCatalogConnect({
        data: payload
      })
      if (response.status === 200) {
        await dispatch('updateBotDetail')
        return { isSuccess: true }
      } else {
        return { isSuccess: false, message: response.data.message }
      }
    } catch (error) {
      console.error({ error })
      return {
        isSuccess: false,
        message:
          error.response.data && error.response.data.message ? error.response.data.message : ''
      }
    }
  },
  disconnectMetaCatalog: async function ({ state, dispatch }) {
    try {
      dispatch('loading')
      const response = await facebookShopApi.deleteCatalogConnect({
        pageId: state.selectedBot.pageid
      })
      if (response.status === 200) {
        await dispatch('updateBotDetail')
        return { isSuccess: true }
      } else {
        return { isSuccess: false, message: response.data.message }
      }
    } catch (error) {
      console.error({ error })
      return {
        isSuccess: false,
        message:
          error.response.data && error.response.data.message ? error.response.data.message : ''
      }
    } finally {
      dispatch('loading')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js